
function removeProtocol(path: string): string {
  return path.replace(/http(s)?:/, '');
}

const getEncodedPlaceholder = (size: string) => {
  const [x, y] = size.split('x')
  const w = parseInt(x);
  const h = y ? w : parseInt(y);
  const svg = `
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}">
        <rect width="${w}" height="${h}" fill="#C4C4C4"/>
        <circle cx="${0.7*w}" cy="${0.3*h}" r="${0.2*w}" fill="#BFA7A7"/>
        <rect x="${0.1*w}" y="${0.5*h}" width="${0.4*w}" height="${0.4*h}" fill="#BFA7A7"/>
      </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg.replace( /[\r\n]+/gm, ''))}`;
}

/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
export function getSizedImageUrl(src: string, size?: string): string {

  if (!src && size === null) {
    console.info('No image or size specified')
    return getEncodedPlaceholder('100x100')
  }

  if (!src) {
    console.info('No image specified');
    return getEncodedPlaceholder(size)
  }

  if (size === null) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];

    return removeProtocol(`${prefix[0]}_${size}${suffix}`);
  } else {
    return null;
  }
}